import Select from '../Select';
import TaggableInput from '../TaggableInput.jsx';
import ExperimentalBadge from '~/components/ExperimentalBadge.jsx';
import InfoMessageBlock from '~/components/InfoMessageBlock.jsx';
import { getOptionsFromSchema } from '~/components/flows/SmsSettings.jsx';

const PhoneCallSettings = ({ settings, setSettings, schema }) => {
    const phoneOptions = getOptionsFromSchema('phone', schema);

    // If the 'to' isn't in the list, add it
    if (settings?.to && !phoneOptions[settings?.to]) {
        phoneOptions[settings?.to] = settings?.to;
    }

    return (
        <div>
            <InfoMessageBlock className="mb-4">
                <ExperimentalBadge className="w-32" /> Make a phone call using AI voice. This is an experimental feature and is limited to 5 phone calls per day.
                This currently has no additional charge, but in the future it will cost an additional $0.75 per call.
            </InfoMessageBlock>

            <Select
                label="Phone Number to Call"
                value={settings?.to || ''}
                onChange={value => setSettings(old => ({ ...old, to: value }))}
                options={phoneOptions}
            />
            <div className="text-sm text-gray-500 mt-1">
                Select the phone number field to call
            </div>

            <div className="input-label mt-6">Message to Say</div>
            <TaggableInput
                schema={schema}
                className="min-h-20"
                initialValue={settings?.message || ''}
                onChange={value => setSettings({ ...settings, message: value })}
                placeholder="Enter the message the AI should say during the call..."
            />
            <div className="text-sm text-gray-500 mt-1">
                The AI will speak this message during the phone call. Keep it conversational and natural.
            </div>
        </div>
    );
};

export default PhoneCallSettings;
